<template>
  <div class='EnbMarketingSeo'>
    <enb-seo/>
    <enb-seo-frente-loja/>
    <enb-seo-login/>
    <enb-seo-categorias/>
    <tag-manager/>
  </div>
</template>

<script>
import EnbSeo from '../Preferencia/EnbSeo'
import EnbSeoFrenteLoja from '../Preferencia/EnbSeoFrenteLoja'
import EnbSeoLogin from '../Preferencia/EnbSeoLogin'
import EnbSeoCategorias from '../Preferencia/EnbSeoCategorias'
import TagManager from '../Preferencia/TagManager'
export default {
  name: 'EnbMarketingSeo',
  components: { EnbSeo, EnbSeoFrenteLoja, EnbSeoLogin, EnbSeoCategorias, TagManager }
}
</script>

<style scoped>
.EnbMarketingSeo {
  padding: 1%;
}
</style>
